import { useFindOrganizationUsers } from "~/gen/api"

export const useFindOrganizationUsersQuery = () => useFindOrganizationUsers()
